import { Fragment } from 'react';

import OrgUnitAdminRosterSelectionLargeGrid from './OrgUnitAdminRosterSelectionLargeGrid';
import OrgUnitAdminRosterSelectionSmallGrid from './OrgUnitAdminRosterSelectionSmallGrid';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitAdminRosterSelectionGrid = ({ gridData, isLoading, onCheckboxChange, onYesNoSwitchChange, allowRelayOnly }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            {gridData.length > 499
              ? <p className={global.ErrorMessage}>More than 500 Search Results returned. Please add additional filters to narrow your search results.</p> :
              <p>{gridData.length === 1 ? `${gridData.length} Search Result` : `${gridData.length} Search Results`}</p>}
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <OrgUnitAdminRosterSelectionLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
        onYesNoSwitchChange={onYesNoSwitchChange}
        allowRelayOnly={allowRelayOnly}
      />
      <OrgUnitAdminRosterSelectionSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
        onYesNoSwitchChange={onYesNoSwitchChange}
        allowRelayOnly={allowRelayOnly}
      />
    </Fragment>
  )
};

export default OrgUnitAdminRosterSelectionGrid;